const isConfigurableProduct = (product) => {
    const productTypes = product.Result.product_types || [];
    return productTypes.indexOf(16384) !== -1;
};
export default isConfigurableProduct;
//# sourceMappingURL=is-configurable-product.js.map